import { useAdminTranslation } from 'hooks/use-translation';
import React from 'react';
import { IBlockRegion } from '../utils';

const TableHeader = ({ isRanked, region }: { isRanked: boolean; region: IBlockRegion; }) => {
  const { t } = useAdminTranslation();

  return (
    <thead>
      {
        isRanked ? (
          <tr>
            <th>{region === 'panel' ? '#' : t('PLACE')}</th>
            <th>{region === 'panel' ? 'D' : t('DIVISION')}</th>
            <th>{t('PLAYER_NAME')}</th>
          </tr>
        ) : (
          <tr>
            <th>{region === 'panel' ? '#' : t('PLACE')}</th>
            <th>{t('PLAYER_NAME')}</th>
            <th>{region === 'panel' ? 'P' : t('LABEL_POINTS')}</th>
            <th>VRs</th>
            <th>{region === 'panel' ? 'M' : t('MATCHES')}</th>
            <th>{region === 'panel' ? 'E' : t('ELIMS')}</th>
          </tr>
        )
      }
    </thead>
  );
};

export default TableHeader;
